import { useMixpanel as useMixpanelContext } from '@src/context/MixpanelContext';

export const useMixpanel = () => {
  const { mixpanel, trackEvent } = useMixpanelContext();

  return { mixpanel, trackEvent };
};
